module.exports = __webpack_public_path__ + "static/hypothesize-observe-745f24ca1472545bf11781f385c3fe58.svg";